const and = (...predicates) => {
  return traffic => {
    return predicates.every(predicate => {
      return predicate(traffic)
    })
  }
}

export default and



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/and.js